<sl-title [title]="pageTitle"></sl-title>
<div class="container-fluid coa-import-tool">
	<sl-table [data]="data" [config]="tableConfig" [filters]="filters"></sl-table>
	<div class="row searchParams" style="margin-bottom: 25px;">
		<div class="col-xs-12">
			<button name="fileImport" mat-flat-button color="primary" style="margin-top: 50px;" appearance="fill" id="importCOAFile"
				class="linq-button--primary export-button mx-1 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
				(click)="beginImport()">Begin Import Wizard
			</button>

		</div>
	</div>
</div>